export default __webpack_public_path__ + "static/media/hks2.4e7fd20e.jpg";